export enum AtlasTool {
  Select = "Select",
  Pan = "Pan",
  Sticky = "Sticky",
  Text = "Text",
  Rectangle = "Rectangle",
  RoundedRectangle = "Rounded rectangle",
  Ellipse = "Ellipse",
  Diamond = "Diamond",
  Triangle = "Triangle",
  InvertedTriangle = "Inverted triangle",
  Line = "Line",
  Cylinder = "Cylinder",
  Document = "Document",
  MultipleDocument = "Multiple document",
  Parallelogram = "Parallelogram",
  Trapezoid = "Trapezoid",
  PredefinedProcess = "Predefined process",
  Cloud = "Cloud",
  Connector = "Connector",
  Frame = "Frame",
  Image = "Image",
  Embed = "Embed",
}
